<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name: 'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Vehículos</span>
                            </li>
                            <li class="active">
                                <span>{{ vehicleId ? 'Editar': 'Crear'}} vehículo</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        {{ vehicleId ? 'Editar': 'Crear'}} vehículo
                    </h2>
                    <small>{{ vehicleId ? 'Editar': 'Crear'}} vehículo</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Vehículo
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <div class="form-group typeFile">
                                <label class="control-label">Foto de vehículo</label>
                                <div id="vehiclePic">
                                    <div class="dz-default dz-message" data-dz-message="">
                                    <span class="imgCtn" v-if="!form.vehiclePic && !uploadingVehiclePic">
                                        <i class="fa fa-camera fa-2x"></i>
                                        <p>Añadir foto</p>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group typeFile">
                                <label class="control-label">Foto de conductor</label>
                                <div id="driverPic">
                                    <div class="dz-default dz-message" data-dz-message="">
                                    <span class="imgCtn" v-if="!form.driverPic && !uploadingDriverPic">
                                        <i class="fa fa-camera fa-2x"></i>
                                        <p>Añadir foto</p>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <p class="m-t-md">
                                <strong>Vehículo</strong> será asignado a los viajes de forma manual o automática en
                                base a la configuración.<br><br>
                                <strong>Importante:</strong> El usuario y contraseña serán usados por el
                                conductor para poder ingresar al Aplicativo Conductor.
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-3 form-group">
                                    <label>Tipo *</label>
                                    <custom-input tipo="select" :field="$v.form.type" :items="vehicleTypes"/>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Placa *</label>
                                    <custom-input tipo="text" :field="$v.form.plate" placeholder="ABC-123"/>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Marca *</label>
                                    <custom-input tipo="select" :field="$v.form.brand" :items="carBrands"/>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Color *</label>
                                    <custom-input tipo="select" :field="$v.form.color" :items="colors"/>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Nombre de conductor *</label>
                                    <custom-input tipo="text" :field="$v.form.driverName"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>DNI de conductor *</label>
                                    <custom-input tipo="text" :field="$v.form.driverId"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Celular de conductor *</label>
                                    <custom-input tipo="text" :field="$v.form.driverPhone"/>

                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Usuario *</label>
                                    <custom-input tipo="text" :field="$v.form.username" disabled/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Contraseña *</label>
                                    <custom-input tipo="text" :field="$v.form.password"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save" :disabled="uploadingVehiclePic || uploadingDriverPic">Guardar</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {VEHICLE_EDIT, VEHICLE_LIST, VEHICLE_NEW} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import {plate} from "../../directives/customValidations"
    import Util from '../../util/util';
    import {alphaNum, maxLength, required, numeric} from 'vuelidate/lib/validators'
    import * as carBrands from '../../assets/json/carBrands'
    import {colorList, vehicleTypeList} from '../../util/selectOptions'
    import VehicleService from '../../services/VehicleService';
    import Alert from "../../util/alert";
    import {AUTH_TOKEN} from "../../util/constants";

    export default {
        name: VEHICLE_EDIT.name,
        props: ['vehicleId'],
        components: {CustomInput},
        data: () => ({
            driverPicUrl: null,
            carBrands: carBrands,
            colors: colorList,
            vehicleTypes: vehicleTypeList,
            driverPicLoading: false,
            uploadingVehiclePic: false,
            uploadingDriverPic: false,
            vehicleDropzone: null,
            form: {
                plate: null,
                brand: null,
                color: null,
                type: null,
                vehiclePic: null,
                username: null,
                password: null,
                driverName: null,
                driverPhone: null,
                driverId: null,
                driverPic: null,
            }
        }),
        computed: {
            vehiclePlate() {
                return this.form.plate;
            }
        },
        watch: {
            vehicleId: function () {
                if (this.vehicleId) {
                    this.clear();
                    this.init(this.vehicleId);
                } else {
                    this.clear();
                }

            },
            vehiclePlate: function (val) {
                const self = this;
                if (val)
                    self.form.username = val.replace(/[^a-z0-9]/gi, '').toUpperCase();
            },
        },
        validations: {
            form: {
                plate: {required, plate},
                brand: {required},
                color: {required},
                type: {required},
                driverPhone: {required},
                driverName: {required, maxLength: maxLength(100)},
                driverId: {required, maxLength: maxLength(12), numeric},
                username: {alphaNum, required, maxLength: maxLength(20)},
                password: {required, maxLength: maxLength(20)}
            }
        },
        methods: {
            async init(vehicleId) {
                const self = this;
                if (vehicleId) {
                    try {
                        const vehicle = (await VehicleService.getVehicle(vehicleId)).data.payload;
                        self.load(vehicle);
                        self.initDropzones();
                    } catch (e) {
                        Alert.mensajeError(e.message);
                        this.$router.push({path: VEHICLE_NEW.route})
                    }
                } else {
                    self.initDropzones();
                }
            },
            load(vehicle) {
                const self = this;
                self.form.plate = vehicle.plate;
                self.form.brand = Util.getOptionByKey(carBrands, vehicle.brand);
                self.form.color = Util.getOptionByKey(colorList, vehicle.color);
                self.form.type = Util.getOptionByKey(vehicleTypeList, vehicle.type);
                self.form.username = vehicle.username;
                self.form.password = vehicle.password;
                self.form.vehiclePic = vehicle.vehiclePic;
                self.form.driverName = vehicle.driverName;
                self.form.driverPhone = vehicle.driverPhone;
                self.form.driverPic = vehicle.driverPic;
                self.form.driverId = vehicle.driverId;

            },
            async save() {
                const self = this;
                self.$v.$touch();
                if (self.$v.$error) return;

                if (!self.form.driverPic) {
                    Alert.mensajeError('Por favor carga la imagen del conductor')
                    return;
                }

                if (!self.form.vehiclePic) {
                    Alert.mensajeError('Por favor carga la imagen del vehículo')
                    return;
                }

                const data = {
                    ...self.form, ...{
                        brand: self.form.brand ? self.form.brand.key : null,
                        color: self.form.color ? self.form.color.key : null,
                        type: self.form.type ? self.form.type.key : null
                    }
                };
                try {
                    if (self.vehicleId) {
                        const vehicleUpdated = (await VehicleService.updateVehicle(self.vehicleId, data)).data.payload;
                        self.load(vehicleUpdated);
                        Alert.mensajeExito("Vehículo actualizado.");
                        self.$router.push({path: VEHICLE_LIST.route});
                    } else {
                        await VehicleService.addVehicle(data);
                        Alert.mensajeExito("Vehículo creado.");
                        self.$router.push({path: VEHICLE_LIST.route});
                    }
                    self.$v.$reset();
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            initDropzones: function () {
                const self = this;
                const token = localStorage.getItem(AUTH_TOKEN);
                if (!self.vehicleDropzone) {
                    self.vehicleDropzone = new Dropzone(`#vehiclePic`,
                        {
                            paramName: "asset", // The name that will be used to transfer the file
                            maxFilesize: 8, // MB
                            maxFiles: 1, // MB
                            acceptedFiles: ".png, .jpeg, .jpg",
                            addRemoveLinks: true,
                            previewTemplate: "<div class=\"dz-default dz-message dz-preview dz-file-preview\"><span class=\"imgCtn\"><img data-dz-thumbnail/></span></div>",
                            url: `${process.env.SVC_URL}/asset`,
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Cache-Control': null,
                                'X-Requested-With': null,
                            },
                            dictCancelUploadConfirmation: "¿Está seguro que desea cancelar la carga?",
                            dictCancelUpload: "Cancelar carga",
                            dictRemoveFile: "Remover",
                            init: function () {
                                // detail.initialized = true;
                                const dropzoneThis = this;
                                this.on("maxfilesexceeded", function (file) {
                                    dropzoneThis.removeAllFiles();
                                    dropzoneThis.addFile(file);
                                });

                                this.on("removedfile", function (file) {
                                    self.form.vehiclePic = null;
                                });

                                this.on("maxfilesizeexceeded", function (file) {
                                    dropzoneThis.removeFile(file);
                                    Alert.mensajeError("Error, el archivo de imagen no debe exceder los 8MB");
                                });

                                this.on("success", function (file, response) {
                                    self.uploadingVehiclePic = false;
                                    self.form.vehiclePic = response.url;
                                    // detail.imageUrl = response.url;
                                });

                                this.on("error", function (file, data) {
                                    // TODO: Show message on upload error
                                    if (data === 'You can not upload any more files.') {
                                        dropzoneThis.removeFile(file);
                                    } else {
                                        self.uploadingVehiclePic = false;
                                        Alert.mensajeError('Ocurrió un error al cargar imagen.');
                                    }
                                    self.form.vehiclePic = null;
                                });

                                this.on("sending", function (file, xhr, formData) {
                                    self.uploadingVehiclePic = true;
                                });
                            }
                        });
                }

                if (self.form.vehiclePic) {
                    let mockFile = {name: "logo", dataURL: self.form.vehiclePic, accepted: true};
                    self.vehicleDropzone.files.push(mockFile);
                    self.vehicleDropzone.emit("addedfile", mockFile);
                    self.vehicleDropzone.createThumbnailFromUrl(mockFile,
                        self.vehicleDropzone.options.thumbnailWidth,
                        self.vehicleDropzone.options.thumbnailHeight,
                        self.vehicleDropzone.options.thumbnailMethod, true, function (thumbnail) {
                            self.vehicleDropzone.emit('thumbnail', mockFile, thumbnail);
                        }, "Anonymous");
                    self.vehicleDropzone.emit('complete', mockFile);
                }

                if (!self.driverDropzone) {
                    self.driverDropzone = new Dropzone(`#driverPic`,
                        {
                            paramName: "asset", // The name that will be used to transfer the file
                            maxFilesize: 8, // MB
                            maxFiles: 1, // MB
                            acceptedFiles: ".png, .jpeg, .jpg",
                            addRemoveLinks: true,
                            previewTemplate: "<div class=\"dz-default dz-message dz-preview dz-file-preview\"><span class=\"imgCtn\"><img data-dz-thumbnail/></span></div>",
                            url: `${process.env.SVC_URL}/asset`,
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Cache-Control': null,
                                'X-Requested-With': null,
                            },
                            dictCancelUploadConfirmation: "¿Está seguro que desea cancelar la carga?",
                            dictCancelUpload: "Cancelar carga",
                            dictRemoveFile: "Remover",
                            init: function () {
                                // detail.initialized = true;
                                const dropzoneThis = this;
                                this.on("maxfilesexceeded", function (file) {
                                    dropzoneThis.removeAllFiles();
                                    dropzoneThis.addFile(file);
                                });

                                this.on("removedfile", function (file) {
                                    self.form.driverPic = null;
                                });

                                this.on("maxfilesizeexceeded", function (file) {
                                    dropzoneThis.removeFile(file);
                                    Alert.mensajeError("Error, el archivo de imagen no debe exceder los 8MB");
                                });

                                this.on("success", function (file, response) {
                                    self.uploadingDriverPic = false;
                                    self.form.driverPic = response.url;
                                    // detail.imageUrl = response.url;
                                });

                                this.on("error", function (file, data) {
                                    // TODO: Show message on upload error
                                    if (data === 'You can not upload any more files.') {
                                        dropzoneThis.removeFile(file);
                                    } else {
                                        self.uploadingDriverPic = false;
                                        Alert.mensajeError('Ocurrió un error al cargar imagen.');
                                    }
                                    self.form.driverPic = null;
                                });

                                this.on("sending", function (file, xhr, formData) {
                                    self.uploadingDriverPic = true;
                                });
                            }
                        });
                }


                if (self.form.driverPic) {
                    let mockFile = {name: "logo", dataURL: self.form.driverPic, accepted: true};
                    self.driverDropzone.files.push(mockFile);
                    self.driverDropzone.emit("addedfile", mockFile);
                    self.driverDropzone.createThumbnailFromUrl(mockFile,
                        self.driverDropzone.options.thumbnailWidth,
                        self.driverDropzone.options.thumbnailHeight,
                        self.driverDropzone.options.thumbnailMethod, true, function (thumbnail) {
                            self.driverDropzone.emit('thumbnail', mockFile, thumbnail);
                        }, "Anonymous");
                    self.driverDropzone.emit('complete', mockFile);
                }
            },
            clear() {
                const self = this;
                self.driverPicUrl = null;
                self.form.plate = self.form.brand = self.form.color = self.form.type =
                    self.form.driverName = self.form.username = self.form.password = self.form.driverPicId = self.form.driverId = null;
                self.form.driverPhone = '';
            }
        },
        mounted() {
            this.init(this.vehicleId);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/vehicle/VehicleEditor.vue